import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

let msalInstance: PublicClientApplication | null = null;
let initializationPromise: Promise<void> | null = null;

export const getMsalInstance = async (): Promise<PublicClientApplication> => {
  if (msalInstance) {
    return msalInstance;
  }

  if (initializationPromise) {
    await initializationPromise;
    return msalInstance!;
  }

  initializationPromise = (async () => {
    try {
      msalInstance = new PublicClientApplication(msalConfig);
      await msalInstance.initialize();
    } catch (error) {
      console.error("Failed to initialize MSAL:", error);
      throw error;
    }
  })();

  await initializationPromise;
  return msalInstance!;
};

export const isMsalConfigured = (): boolean => {
  return !!(
    process.env.REACT_APP_MS_CLIENT_ID && process.env.REACT_APP_MS_TENANT_ID
  );
};
